module.exports = __webpack_public_path__ + "img/lordsmobile.13a659c.jpg";